module.exports = __webpack_public_path__ + "static/media/wprost.205cbc18.svg";